import { render, staticRenderFns } from "./insuranceMaintContracts.vue?vue&type=template&id=127223b9"
import script from "./insuranceMaintContracts.vue?vue&type=script&lang=js"
export * from "./insuranceMaintContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports